document.addEventListener('DOMContentLoaded', function() {
  const widgetContainers = document.querySelectorAll('.custom-widget');
  if (!widgetContainers.length) return;

  widgetContainers.forEach(widget => {
    const sectionId = widget.getAttribute('data-section-id');
    const hiddenSellingPlan = widget.querySelector('input[name="selling_plan"]');

    // Update price display for a given type ('one' or 'sub')
    function updatePrice(price, forType) {
      const priceSpan = widget.querySelector(`.pricene[data-for="${forType}"]`);
      if (priceSpan) {
        priceSpan.innerHTML = price;
      }
    }

    // Show only the price span matching selectedType, hide the rest
    function togglePriceVisibility(selectedType) {
      widget.querySelectorAll('.pricene').forEach(span => {
        span.style.display = (span.dataset.for === selectedType) ? 'inline' : 'none';
      });
    }

    // Hide all subscription dropdowns
    function hideAllSubSelects() {
      widget.querySelectorAll('[data-subscription-select]').forEach(el => {
        el.style.display = 'none';
      });
    }

    // Initially hide all prices
    togglePriceVisibility('none');

    // Listen for radio changes
    widget.querySelectorAll('input[type="radio"]').forEach(radio => {
      radio.addEventListener('change', () => {
        const subscriptionNotes = document.querySelector('[data-subscription-notes]');
        let selectedType = '';

        if (radio.dataset.radioType === 'one_time_purchase') {
          // hide ALL dropdowns
          hideAllSubSelects();
          if (subscriptionNotes) subscriptionNotes.style.display = 'none';
          hiddenSellingPlan.value = '';
          updatePrice(radio.dataset.variantPrice, 'one');
          selectedType = 'one';

        } else if (radio.dataset.radioType === 'selling_plan_group') {
          // Find the correct dropdown based on the data-group-id that matches the radio frequency.
          const groupId = radio.dataset.sellingPlanGroupId;
          const subSelectContainer = widget.querySelector(`[data-subscription-select][data-group-id="${groupId}"]`);
          const subSelect = subSelectContainer
            ? subSelectContainer.querySelector('select.selected-selling-plan-select')
            : null;

          // Hide everything first, then only show what's in the right group.
          hideAllSubSelects();
          if (subSelectContainer) subSelectContainer.style.display = 'grid';
          if (subscriptionNotes) subscriptionNotes.style.display = 'block';

          if (subSelect && subSelect.options.length > 0) {
            const firstOption = subSelect.options[0];
            subSelect.value = firstOption.value;
            hiddenSellingPlan.value = firstOption.value;
            updatePrice(firstOption.dataset.price, 'sub');
            selectedType = 'sub';
          } else {
            hiddenSellingPlan.value = '';
          }
        }

        togglePriceVisibility(selectedType);
      });
    });

    // Listen for delivery frequency select changes
    widget.querySelectorAll('.selected-selling-plan-select').forEach(select => {
      select.addEventListener('change', (e) => {
        hiddenSellingPlan.value = e.target.value;
        const selectedOption = e.target.options[e.target.selectedIndex];
        updatePrice(selectedOption.dataset.price, 'sub');
        togglePriceVisibility('sub');
      });
    });

    // Handle variant changes
    const variantSelector =
      document.querySelector('select[name="id"]') ||
      document.querySelector('input[name="id"]');

    if (variantSelector) {
      variantSelector.addEventListener('change', (e) => {
        const newVariantId = e.target.value;

        widget.querySelectorAll('.selling_plan_theme_integration').forEach(sec => {
          sec.classList.toggle(
            'selling_plan_theme_integration--hidden',
            sec.dataset.variantId !== newVariantId
          );
        });

        const activeRadio = widget.querySelector(
          '.selling_plan_theme_integration:not(.selling_plan_theme_integration--hidden) input[type="radio"]:checked'
        );

        if (activeRadio) {
          activeRadio.dispatchEvent(new Event('change'));
        } else {
          hiddenSellingPlan.value = '';
          hideAllSubSelects();
          togglePriceVisibility('none');
        }
      });
    }

    // Initialize: trigger change on the default checked radio
    const defaultRadio = widget.querySelector(
      '.selling_plan_theme_integration:not(.selling_plan_theme_integration--hidden) input[type="radio"]:checked'
    );
    if (defaultRadio) {
      defaultRadio.dispatchEvent(new Event('change'));
    }
  });
});